module.exports = __webpack_public_path__ + "img/slider_galery_1.b5550b78.jpg";